import React from 'react';
import ReportList from './ReportList';

const SurveyList = ({onSelect}: { onSelect: (report: { title: string; date: string; pdfSrc: string }) => void }) => (
    <ReportList categorySlug="survey" heading="Surveys" onSelect={onSelect}/>
);

export default SurveyList;
